import { AfterContentInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { ModalService } from '../../../../services/modal.service'
import 'nvd3'
import * as moment from 'moment'
import * as $ from 'jquery'
import Constants from '../../../../commons/Constants'
import { Subscription } from 'rxjs'
import { distinctUntilChanged } from 'rxjs/operators'

declare let d3: any

@Component({
    selector: 'app-compliance',
    templateUrl: './compliance.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './compliance.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../../../../node_modules/nvd3/build/nv.d3.css'],
    encapsulation: ViewEncapsulation.None,
})
export class ComplianceComponent implements OnInit, AfterContentInit, OnDestroy {

    en = {}
    showEN = true
    idClient
    activeTab: string = ''
    activeDevice: any = null
    devices = Constants.ACCELEDENT_DEVICES
    resourceUrl = 'resource'
    listClientCompliance: any
    listAligner: any
    listStaff: any
    modalComplianceAccele = ''
    modalComplianceOthopulse = 'hidden'
    accelationDevice: string = ''
    options
    data
    optionsDevice
    dataDevice
    averageTimeUsage = 0
    percentAverage = 0
    averageTimeUsageDevice = 0
    arrayDataAligner = []
    arrayDataAligner2 = []
    arrayDataDevice = []
    arrayDataDevice2 = []
    listCompliance
    chartWidth
    listClientAligner
    _listAligner
    listComplianceFilter = null
    textAlignerFilter = 'All Aligners'
    noAlignerActive = true
    displayDeviceChart = false
    shareSubscription: Subscription
    activeReg = true;

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private route: ActivatedRoute, private modalService: ModalService) {
        this.shareSubscription = this._sharedService.changeEmittedSource$.pipe(distinctUntilChanged()).subscribe(
            success => {
                if (success) {
                    if (success[0] === 'saveComplianceOrthoPulse') {
                        this.saveAcceledentDevice()
                    } else if (success[0] === 'selectedIdFillter') {

                        let dataFilter = this.listCompliance
                        if (success[1] != 'all') {
                            this.listComplianceFilter = dataFilter.filter(el => {
                                return el['targetAligner'] == success[1]
                            })
                            this.textAlignerFilter = success[2]
                            this.caculatorData(this.listComplianceFilter)
                            // this.caculatorDataDevice(this.listComplianceFilter);
                            if (this.displayDeviceChart) {
                                this.caculatorDataDevice(this.listComplianceFilter)
                            } else {
                                this.averageTimeUsageDevice = 0
                                this.arrayDataDevice = []
                                this.arrayDataDevice2 = []
                            }
                        } else {
                            this.listComplianceFilter = null
                            this.textAlignerFilter = 'All Aligners'
                            this.caculatorData()
                            if (this.displayDeviceChart) {
                                this.caculatorDataDevice()
                            } else {
                                this.averageTimeUsageDevice = 0
                                this.arrayDataDevice = []
                                this.arrayDataDevice2 = []
                            }
                            // this.caculatorDataDevice();
                        }
                    } else {
                        const listClientComplianceData = this.listClientCompliance = success[0]
                        this.listCompliance = success[0]
                        const listStaffData = this.listStaff = success[1]
                        listClientComplianceData.forEach((item) => {
                            this.prettyDataTable(listStaffData, item)
                        })
                        this.listClientCompliance.sort((function(obj1, obj2) {
                            return obj2.visitDate - obj1.visitDate
                        }))
                    }
                }
            })
    }

    ngOnInit() {
        const emit: any = {}
        emit['status'] = 'hide'
        emit['view'] = 'client-compliance'
        this._sharedService.emitChangeIsShowConfirm(emit)
        this.route.parent.paramMap.subscribe((params: ParamMap) => {
            this.idClient = params.get('id')
        })
        this.options = {
            chart: {
                type: 'discreteBarChart',
                height: 450,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 55,
                },
                // xRange:[0,240],
                yDomain: [0, 24],
                x: function(d) {
                    return d.label
                },
                y: function(d) {
                    return d.value
                },
                showValues: false,
                duration: 500,
                xAxis: {},
                yAxis: {
                    ticks: 24,
                    tickFormat: function(d) {
                        if (parseFloat(d) % 6 == 0 || parseFloat(d) == 0) {
                            return parseFloat(d) + 'H'
                        }
                        return null
                    },
                },
                // bars:{
                maxBarWidth: 100,
                // },
                tooltip: {
                    contentGenerator: function(e) {
                        var series = e.series[0]
                        if (series.value === null) return

                        var rows =
                            '<tr>' +
                            '<td class=\'key\'>' + 'Usage' + '</td>' +
                            '<td class=\'x-value\'>' + (series.value ? parseFloat(series.value) + 'H' : 0 + 'H') + '</td>' +
                            '</tr>'

                        var header =
                            '<thead>' +
                            '<tr>' +
                            '<td class=\'key\'><strong>' + series.key + '</strong></td>' +
                            '</tr>' +
                            '</thead>'

                        return '<table>' +
                            header +
                            '<tbody>' +
                            rows +
                            '</tbody>' +
                            '</table>'
                    },
                },
            },
        }
        this.optionsDevice = {
            chart: {
                type: 'discreteBarChart',
                height: 450,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 55,
                },
                yDomain: [0, 100],
                x: function(d) {
                    return d.label
                },
                y: function(d) {
                    return d.value
                },
                showValues: false,
                duration: 500,
                xAxis: {},
                yAxis: {
                    ticks: 6,
                    tickFormat: function(d) {
                        return parseFloat(d) + '%'
                    },
                },
                tooltip: {
                    contentGenerator: function(e) {
                        var series = e.series[0]
                        if (series.value === null) return

                        var rows =
                            '<tr>' +
                            '<td class=\'key\'>' + 'Usage' + '</td>' +
                            '<td class=\'x-value\'>' + (series.value ? parseFloat(series.value) + '%' : 0 + '%') + '</td>' +
                            '</tr>'

                        var header =
                            '<thead>' +
                            '<tr>' +
                            '<td class=\'key\'><strong>' + series.key + '</strong></td>' +
                            '</tr>' +
                            '</thead>'

                        return '<table>' +
                            header +
                            '<tbody>' +
                            rows +
                            '</tbody>' +
                            '</table>'
                    },
                },
            },
        }

        this.mainClient()
    }

    ngAfterContentInit() {
        this.chartWidth = $('#chart-parent').width()
    }

    ngOnDestroy(): void {
        if(this.shareSubscription)
            this.shareSubscription.unsubscribe()
    }

    mainClient() {
        this.callApiTabCompliance()
    }

    changLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }


    selectAcceleDent(device: any) {
        this.accelationDevice = device.value
        this.changeActiveTab('r_' + this.accelationDevice)

        const arrSaveConfirm = ['activeAlertSaveComplice', this.idClient, this.accelationDevice]
        this._sharedService.emitChange(arrSaveConfirm)
    }

    showComplianceEffectTab() {
        this.changeActiveTab('effect')
        this.activeReg = false
        this.modalComplianceAccele = 'hidden'
        this.modalComplianceOthopulse = 'hidden'
    }

    showComplianceAlignerTab() {
        this.changeActiveTab('aligner')
        this.activeReg = false
        this.modalComplianceAccele = 'hidden'
        this.modalComplianceOthopulse = 'hidden'
        this.listCompliance.sort((function(obj1, obj2) {
            return obj1.visitDate - obj2.visitDate
        }))
        this.caculatorData(this.listComplianceFilter)
    }

    showComplianceDeviceTab() {
        this.changeActiveTab('device')
        this.activeReg = false
        this.modalComplianceAccele = 'hidden'
        this.modalComplianceOthopulse = 'hidden'
        this.listCompliance.sort((function(obj1, obj2) {
            return obj1.visitDate - obj2.visitDate
        }))
        if (this.displayDeviceChart) {
            this.caculatorDataDevice(this.listComplianceFilter)
        } else {
            this.averageTimeUsageDevice = 0
            this.arrayDataDevice = []
            this.arrayDataDevice2 = []
        }
    }

    showComplianceRegistrationTab() {
        this.changeActiveTab('r_' + this.accelationDevice)
        this.activeReg = true
        this.listCompliance.sort((function(obj1, obj2) {
            return obj2.visitDate - obj1.visitDate
        }))
    }

    editComplice(idCompilece) {
        const arrCompliece = ['activeCompliceEdit', idCompilece._id, idCompilece, null, idCompilece.targetAligner, this._listAligner]
        this._sharedService.emitChange(arrCompliece)
    }


    editCompliceOrthoPulse(idCompilece) {
        const arrCompliece = ['activeCompliceEdit', idCompilece._id, idCompilece, 'ratio', idCompilece.targetAligner, this._listAligner]
        this._sharedService.emitChange(arrCompliece)
    }


    callApiTabCompliance() {
        const clientId = {}
        const result = this.idClient
        clientId[result] = true

        const clientIdCompare = {}
        const resultclientIdCompare = '{"clientId":"' + this.idClient + '"}'
        clientIdCompare[resultclientIdCompare] = true

        const resourceDataAccessLog = {
            actions: [],
            status: {
                client: {
                    map: clientId,
                },
                clientAligner: {
                    paths: clientIdCompare,
                },
                clientCompliance: {
                    paths: clientIdCompare,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                        alignerMail: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {

            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    const activeAlignerId = success['response']['client']['map'][this.idClient].activeAligner
                    this.accelationDevice = success['response']['client']['map'][this.idClient].accelationDevice
                    this.changeActiveTab('r_' + this.accelationDevice)

                    this.listClientAligner = success['response']['client']['map'][this.idClient]
                    this.listCompliance = success['response']['clientCompliance']['paths'][resultclientIdCompare]
                    const listClientAligner = success['response']['clientAligner']['paths'][resultclientIdCompare]
                    this.listAligner = listClientAligner.find(x => x._id === activeAlignerId)
                    this._listAligner = success['response']['clientAligner']['paths']['{"clientId":"' + this.idClient + '"}']
                    const listClientComplianceData = this.listClientCompliance = success['response']['clientCompliance']['paths'][resultclientIdCompare]
                    const listStaffData = this.listStaff = success['response']['staff']['paths']['{}']
                    listClientComplianceData.forEach((item) => {
                        this.prettyDataTable(listStaffData, item)
                    })
                    if (activeAlignerId) {
                        this.noAlignerActive = false
                    }
                    this.listClientCompliance.sort((function(obj1, obj2) {
                        return obj2.visitDate - obj1.visitDate
                    }))
                },
            )
        })
    }

    newCompliance() {
        const newCompliance = ['activeAddCompliance', this.idClient, this.listClientAligner, this._listAligner, this.accelationDevice]
        this._sharedService.emitChange(newCompliance)
    }

    newComplianceOthopulse() {
        const newCompliance = ['activeAddComplianceOrthoPulse', this.idClient, 'ratio', this.listClientAligner, this._listAligner, this.accelationDevice]
        this._sharedService.emitChange(newCompliance)
    }

    saveAcceledentDevice() {
        const resourcePostDataAccelationDevice = {
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: {
                        accelationDevice: this.accelationDevice,
                    },
                },
            ],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                        alignerMail: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourcePostDataAccelationDevice, tokenReNew).subscribe()
        })
    }

    caculatorData(data = null) {
        let listData
        if (data) {
            listData = data
        } else {
            listData = this.listCompliance
        }
        this.averageTimeUsage = 0
        this.percentAverage = 0
        this.arrayDataAligner = []
        this.arrayDataAligner2 = []
        let totalTime = 0
        for (let i = 0; i < listData.length; i++) {
            let time = moment(listData[i].visitDate).format('DD MMM')
            let usage = 0
            if (this.listCompliance[i].usageTime) {
                usage = this.listCompliance[i].usageTime
            }
            this.arrayDataAligner.push(
                {
                    createTime: time,
                    usageTime: usage,
                },
            )
            totalTime = totalTime + usage
        }
        if (totalTime) {
            this.averageTimeUsage = parseFloat((totalTime / listData.length).toFixed(1))
        }
        let label = ''
        let value = 0

        for (let i = 0; i < this.arrayDataAligner.length; i++) {
            if (label != this.arrayDataAligner[i].visitDate) {
                this.arrayDataAligner2.push(
                    {
                        'label': label,
                        'value': value,
                        'color': '#00A0EA',
                    },
                )
                value = this.arrayDataAligner[i].usageTime
                label = this.arrayDataAligner[i].createTime
                if (this.arrayDataAligner.length === i + 1) {
                    this.arrayDataAligner2.push(
                        {
                            'label': label,
                            'value': value,
                            'color': '#00A0EA',
                        },
                    )
                }
            } else {
                if (value < this.arrayDataAligner[i].usageTime) {
                    value = this.arrayDataAligner[i].usageTime
                }
            }
        }
        let maxUsage = 24
        this.arrayDataAligner2.shift()
        this.percentAverage = parseFloat(((this.averageTimeUsage / maxUsage) * 100).toFixed(2))
        this.data = [
            {
                values: this.arrayDataAligner2,
            },
        ]
        let barsNumber = 0
        let barTitle = ''
        for (let i = 0; i < this.arrayDataAligner2.length; i++) {
            if (this.arrayDataAligner2[i].label != barTitle) {
                barTitle = this.arrayDataAligner2[i].label
                barsNumber++
            }
        }
        let maxBarsNumber = Math.floor(this.chartWidth / 125)
        if (typeof (this.data[0].values) !== 'undefined' && barsNumber > 0 && barsNumber <= maxBarsNumber) {
            this.options.chart.width = 25 + barsNumber * 125
        } else {
            this.options.chart.width = this.chartWidth
        }
    }

    caculatorDataDevice(data = null) {
        let listData
        if (data) {
            listData = data
        } else {
            listData = this.listCompliance
        }
        this.averageTimeUsageDevice = 0
        this.arrayDataDevice = []
        this.arrayDataDevice2 = []
        let raito = 0
        for (let i = 0; i < listData.length; i++) {
            let time = moment(listData[i].visitDate).format('DD MMM')
            let raitoUsage = listData[i].accelerationRatio || 0
            this.arrayDataDevice.push(
                {
                    createTime: time,
                    raitoUsage: raitoUsage,
                },
            )
            raito = raito + raitoUsage
        }
        //
        if (raito) {
            this.averageTimeUsageDevice = Math.round(raito / listData.length)
        }
        let label = ''
        let value = 0

        for (let i = 0; i < this.arrayDataDevice.length; i++) {
            if (label != this.arrayDataDevice[i].visitDate) {
                this.arrayDataDevice2.push(
                    {
                        'label': label,
                        'value': value,
                        'color': '#00A0EA',
                    },
                )
                value = this.arrayDataDevice[i].raitoUsage
                label = this.arrayDataDevice[i].createTime
                if (this.arrayDataDevice.length === i + 1) {
                    this.arrayDataDevice2.push(
                        {
                            'label': label,
                            'value': value,
                            'color': '#00A0EA',
                        },
                    )
                }
            } else {
                if (value < this.arrayDataDevice[i].raitoUsage) {
                    value = this.arrayDataDevice[i].raitoUsage
                }
            }
        }
        this.arrayDataDevice2.shift()
        this.dataDevice = [
            {
                values: this.arrayDataDevice2,
            },
        ]
        let barsNumber = 0
        let barTitle = ''
        for (let i = 0; i < this.arrayDataDevice2.length; i++) {
            if (this.arrayDataDevice2[i].label != barTitle) {
                barTitle = this.arrayDataDevice2[i].label
                barsNumber++
            }
        }
        let maxBarsNumber = Math.floor(this.chartWidth / 125)
        if ((typeof (this.dataDevice[0].values) !== 'undefined') && barsNumber > 0 && barsNumber <= maxBarsNumber) {
            this.optionsDevice.chart.width = 25 + barsNumber * 125
        } else {
            this.optionsDevice.chart.width = this.chartWidth
        }
    }

    filterAligner() {
        //
        const filterAlignerData = ['activeFilterAlignerCompliance', this._listAligner]
        this._sharedService.emitChange(filterAlignerData)
        const emit: any = {}
        emit['status'] = 'hide'
        emit['view'] = 'compliance-all-aligner'
        this._sharedService.emitChangeIsShowConfirm(emit)
    }

    private changeActiveTab(tabName) {
        this.activeTab = tabName
        this.setActiveDevice()

    }

    private setActiveDevice() {
        const device = this.devices.find(item => item.value == this.accelationDevice)
        if (device) {
            this.displayDeviceChart = device.deviceType == 1
            this.activeDevice = device
        }
    }

    private getPageTitle() {
        switch (this.activeTab) {
            case 'effect':
                return this.en['app-client-detail-compliance-Effect']
            case 'aligner':
                return this.en['app-client-detail-compliance-Aligner']
            case 'device':
                return this.en['app-client-detail-compliance-Device']
            default:
                return this.en['app-client-detail-compliance-Registration-btn']
        }
    }

    private prettyDataTable(staffs, item) {
        staffs.forEach(function(StaffItem) {
            if (item.staff === StaffItem._id) {
                if (StaffItem.familyName) {
                    item.operator = StaffItem.firstName + StaffItem.familyName
                    item.deleted = StaffItem.deleted
                } else {
                    item.operator = StaffItem.firstName
                    item.deleted = StaffItem.deleted
                }
            }
        })
        if (item.chewieCompliance == 'good') {
            item.chewieCompliance = 'chewieCompliance-good'
            item.chewieComplianceCheck = 'good'
        }
        if (item.chewieCompliance == 'normal') {
            item.chewieCompliance = 'chewieCompliance-normal'
            item.chewieComplianceCheck = 'normal'
        }
        if (item.chewieCompliance == 'na') {
            item.chewieCompliance = 'chewieCompliance-na'
            item.chewieComplianceCheck = 'na'
        }
        if (item.chewieCompliance == 'bad') {
            item.chewieCompliance = 'chewieCompliance-bad'
            item.chewieComplianceCheck = 'bad'
        }
        if (item.elasticCompliance == 'good') {
            item.elasticCompliance = 'elasticCompliance-good'
            item.elasticComplianceCheck = 'good'
        }
        if (item.elasticCompliance == 'normal') {
            item.elasticCompliance = 'elasticCompliance-normal'
            item.elasticComplianceCheck = 'normal'
        }
        if (item.elasticCompliance == 'na') {
            item.elasticCompliance = 'elasticCompliance-na'
            item.elasticComplianceCheck = 'na'
        }
        if (item.chewieCompliance == 'bad') {
            item.chewieCompliance = 'elasticCompliance-bad'
            item.chewieComplianceCheck = 'bad'
        }

        if (item.chewiePass == 0) {
            item.chewiePassShow = 'ChewiePassed-None'
        } else {
            item.chewiePassShow = 'ChewiePassed-' + item.chewiePass
        }

        if (item.elasticPass == 0) {
            item.elasticPassShow = 'ChewiePassed-None'
        } else {
            item.elasticPassShow = 'ChewiePassed-' + item.elasticPass
        }

        item.modal = 'editCompliance'
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/compliance/compliance.component.ts